import React from "react";
import { IEmailHistoryLog } from "../../redux/emails/Emails.types";
import { RightPanel } from "../../components/RightPanel";
import { Button, Chip, Grid, Stack, Typography, useTheme } from "@mui/material";
import { CustomFormLabel } from "../../components/formsComponents";
import { formatDate, getUniqueId } from "../../helpers";
import { FileUpload } from "../../features/FileUpload/components/FileUpload";

interface IEmailsHistoryLogRightPanelProps {
  open: boolean;
  emailHistoryLog: IEmailHistoryLog;
  onClose: () => void;
}

export const EmailsHistoryLogRightPanel: React.FC<
  IEmailsHistoryLogRightPanelProps
> = ({ open, emailHistoryLog, onClose }) => {
  const theme = useTheme();

  return (
    <>
      <RightPanel
        open={open}
        heading="Email Details"
        onClose={onClose}
        isWrappedWithForm
        actionButtons={() => {
          return (
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Button variant="contained" fullWidth onClick={onClose}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          );
        }}
      >
        <Grid container spacing={1} sx={{ mb: 2 }}>
          <Grid item xs={12} md={6}>
            <CustomFormLabel>Date Created</CustomFormLabel>
            <Typography variant="body2" fontWeight={600}>
              {emailHistoryLog.create_ts ? formatDate(emailHistoryLog.create_ts): "--"}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomFormLabel>Date Modified</CustomFormLabel>
            <Typography variant="body2" fontWeight={600}>
              {emailHistoryLog.insert_ts ? formatDate(emailHistoryLog.insert_ts): "--"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12}>
            <CustomFormLabel>From</CustomFormLabel>
            <Typography variant="body1" fontWeight={500} fontSize={"1rem"}>
              {emailHistoryLog.from_email || "--"}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <CustomFormLabel>To</CustomFormLabel>
            {!emailHistoryLog.to_mail_ids || emailHistoryLog.to_mail_ids.length === 0 ? (
              <Typography variant="body1">--</Typography>
            ) : (
              (emailHistoryLog.to_mail_ids || []).map((email, index) => (
                <Chip label={email} key={index} />
              ))
            )}
          </Grid>
          <Grid item xs={12} md={12}>
            <CustomFormLabel>CC</CustomFormLabel>
            {!emailHistoryLog.cc_mail_ids || emailHistoryLog.cc_mail_ids.length === 0 ? (
              <Typography variant="body1">--</Typography>
            ) : (
              (emailHistoryLog.cc_mail_ids || []).map((email, index) => (
                <Chip label={email} key={index} />
              ))
            )}
          </Grid>
          <Grid item xs={12} md={12}>
            <CustomFormLabel>BCC</CustomFormLabel>
            {!emailHistoryLog.bcc_mail_ids || emailHistoryLog.bcc_mail_ids.length === 0 ? (
              <Typography variant="body1">--</Typography>
            ) : (
             ( emailHistoryLog.bcc_mail_ids || []).map((email, index) => (
                <Chip label={email} key={index} />
              ))
            )}
          </Grid>
          <Grid item xs={12} md={12}>
            <CustomFormLabel>Subject</CustomFormLabel>
            <Typography variant="body1" fontWeight={500} fontSize={"1rem"}>
              {emailHistoryLog.subject || "--"}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <CustomFormLabel>Body</CustomFormLabel>
            <Stack
              sx={{
                p: 1.5,
                border: "1px solid " + theme.palette.divider,
                borderRadius: "5px",
              }}
            >
              <Typography
                variant="body1"
                fontWeight={500}
                fontSize={"1rem"}
                dangerouslySetInnerHTML={{
                  __html: emailHistoryLog.body.content || "N/A",
                }}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} md={12}>
            <CustomFormLabel>Attachments</CustomFormLabel>
            {emailHistoryLog.attachments &&
            emailHistoryLog.attachments.length === 0 ? (
              <Typography variant="body1">--</Typography>
            ) : (
              <>
                <FileUpload
                  multiple
                  value={(emailHistoryLog.attachments
                    ? emailHistoryLog.attachments
                    : []
                  ).map((x) => ({ file: null, key: getUniqueId(), path: x }))}
                  disabled
                  deleteDisabled
                />
              </>
            )}
          </Grid>
           <Grid item xs={12} md={12}>
            <CustomFormLabel>Comment</CustomFormLabel>
            <Typography variant="body1" fontWeight={500} fontSize={"1rem"}>
              {emailHistoryLog.comment || "--"}
            </Typography>
          </Grid>
        </Grid>
      </RightPanel>
    </>
  );
};
